var map = {
	"./cardio.svg": 9867,
	"./dentist.svg": 5498,
	"./dermato.svg": 2595,
	"./gastroentero.svg": 8712,
	"./gen-medicine.svg": 730,
	"./heamato.svg": 5292,
	"./nephro.svg": 5963,
	"./neuro.svg": 9462,
	"./obstetrics.svg": 3109,
	"./onco.svg": 424,
	"./ophthalmo.svg": 3207,
	"./orthopedicst.svg": 2861,
	"./pediatric.svg": 220,
	"./pulmono.svg": 9277,
	"./surgery.svg": 6230,
	"./uro.svg": 3351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5203;